module.exports = __webpack_public_path__ + "media/images/flags/32/Canary-Islands-821b1b854549988f36eab5e78b5f8ecf.png";